import { render } from "./MDetails2.vue?vue&type=template&id=7504dbfa&scoped=true"
import script from "./MDetails2.vue?vue&type=script&lang=js"
export * from "./MDetails2.vue?vue&type=script&lang=js"

import "./MDetails2.vue?vue&type=style&index=0&id=7504dbfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7504dbfa"]])

export default __exports__